"use strict";
/**
 * Encore Foundation - 7.11.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.premiumLiteAlternateSet = exports.premiumLiteSet = exports.spotifyFreeAlternateSet = exports.spotifyFreeSet = exports.premiumFallbackAlternateSet = exports.premiumFallbackSet = exports.basicTierAlternateSet = exports.basicTierSet = exports.audiobooksAccessOnlySet = exports.premiumMiniSet = exports.premiumFamilyAlternateSet = exports.premiumFamilySet = exports.premiumStudentAlternateSet = exports.premiumStudentSet = exports.premiumDuoAlternateSet = exports.premiumDuoSet = exports.premiumAlternateSet = exports.premiumSet = exports.spotifyBrand3AlternateSet = exports.spotifyBrand3Set = exports.spotifyBrand2AlternateSet = exports.spotifyBrand2Set = exports.spotifyBrandAlternateSet = exports.spotifyBrandSet = exports.astroAlternateSet = exports.astroSet = void 0;
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.astroSet = {
    background: {
        base: '#101822',
        highlight: '#182434',
        press: '#2b405b',
        elevated: { base: '#182434', highlight: '#1f2e42', press: '#101822' },
        tinted: { base: '#101822', highlight: '#101822', press: '#101822' },
    },
    text: {
        base: '#ffffff',
        brightAccent: '#f3ff46',
        subdued: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        brightAccent: '#f3ff46',
        subdued: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#1d2b3e' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.astroAlternateSet = {
    background: {
        base: '#f3ff46',
        highlight: '#e2f100',
        press: '#bbc800',
        elevated: { base: '#f3ff46', highlight: '#e2f100', press: '#c7d500' },
        tinted: { base: '#f3ff46', highlight: '#f3ff46', press: '#f3ff46' },
    },
    text: {
        base: '#000000',
        brightAccent: '#101822',
        subdued: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        brightAccent: '#101822',
        subdued: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#d1df00' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyBrandSet = {
    background: {
        base: '#283ea3',
        highlight: '#233790',
        press: '#152054',
        elevated: { base: '#233790', highlight: '#233790', press: '#152054' },
        tinted: { base: '#283ea3', highlight: '#283ea3', press: '#283ea3' },
    },
    text: {
        base: '#1ed760',
        brightAccent: '#ffffff',
        subdued: '#1ed760',
        negative: '#1ed760',
        warning: '#1ed760',
        positive: '#1ed760',
        announcement: '#1ed760',
    },
    essential: {
        base: '#1ed760',
        brightAccent: '#ffffff',
        subdued: '#1ed760',
        negative: '#1ed760',
        warning: '#1ed760',
        positive: '#1ed760',
        announcement: '#1ed760',
    },
    decorative: { base: '#1ed760', subdued: '#324dcb' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyBrandAlternateSet = {
    background: {
        base: '#1ed760',
        highlight: '#3be477',
        press: '#1abc54',
        elevated: { base: '#3be477', highlight: '#3be477', press: '#1abc54' },
        tinted: { base: '#1ed760', highlight: '#1ed760', press: '#1ed760' },
    },
    text: {
        base: '#283ea3',
        brightAccent: '#000000',
        subdued: '#283ea3',
        negative: '#283ea3',
        warning: '#283ea3',
        positive: '#283ea3',
        announcement: '#283ea3',
    },
    essential: {
        base: '#283ea3',
        brightAccent: '#000000',
        subdued: '#283ea3',
        negative: '#283ea3',
        warning: '#283ea3',
        positive: '#283ea3',
        announcement: '#283ea3',
    },
    decorative: { base: '#283ea3', subdued: '#1abc54' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyBrand2Set = {
    background: {
        base: '#c5f0c9',
        highlight: '#e6f9e8',
        press: '#81de8a',
        elevated: { base: '#e6f9e8', highlight: '#e6f9e8', press: '#81de8a' },
        tinted: { base: '#c5f0c9', highlight: '#c5f0c9', press: '#c5f0c9' },
    },
    text: {
        base: '#cd1400',
        brightAccent: '#000000',
        subdued: '#cd1400',
        negative: '#cd1400',
        warning: '#cd1400',
        positive: '#cd1400',
        announcement: '#cd1400',
    },
    essential: {
        base: '#cd1400',
        brightAccent: '#000000',
        subdued: '#cd1400',
        negative: '#cd1400',
        warning: '#cd1400',
        positive: '#cd1400',
        announcement: '#cd1400',
    },
    decorative: { base: '#cd1400', subdued: '#a3e7a9' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyBrand2AlternateSet = {
    background: {
        base: '#cd1400',
        highlight: '#bc1300',
        press: '#8d0e00',
        elevated: { base: '#bc1300', highlight: '#bc1300', press: '#8d0e00' },
        tinted: { base: '#cd1400', highlight: '#cd1400', press: '#cd1400' },
    },
    text: {
        base: '#c5f0c9',
        brightAccent: '#ffffff',
        subdued: '#c5f0c9',
        negative: '#c5f0c9',
        warning: '#c5f0c9',
        positive: '#c5f0c9',
        announcement: '#c5f0c9',
    },
    essential: {
        base: '#c5f0c9',
        brightAccent: '#ffffff',
        subdued: '#c5f0c9',
        negative: '#c5f0c9',
        warning: '#c5f0c9',
        positive: '#c5f0c9',
        announcement: '#c5f0c9',
    },
    decorative: { base: '#c5f0c9', subdued: '#ee1700' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyBrand3Set = {
    background: {
        base: '#fce54f',
        highlight: '#fef4b5',
        press: '#e6c804',
        elevated: { base: '#fef4b5', highlight: '#fef4b5', press: '#e6c804' },
        tinted: { base: '#fce54f', highlight: '#fce54f', press: '#fce54f' },
    },
    text: {
        base: '#b02897',
        brightAccent: '#000000',
        subdued: '#b02897',
        negative: '#b02897',
        warning: '#b02897',
        positive: '#b02897',
        announcement: '#b02897',
    },
    essential: {
        base: '#b02897',
        brightAccent: '#000000',
        subdued: '#b02897',
        negative: '#b02897',
        warning: '#b02897',
        positive: '#b02897',
        announcement: '#b02897',
    },
    decorative: { base: '#b02897', subdued: '#e6c804' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyBrand3AlternateSet = {
    background: {
        base: '#b02897',
        highlight: '#a1258a',
        press: '#771b66',
        elevated: { base: '#a1258a', highlight: '#a1258a', press: '#771b66' },
        tinted: { base: '#b02897', highlight: '#b02897', press: '#b02897' },
    },
    text: {
        base: '#fce54f',
        brightAccent: '#ffffff',
        subdued: '#fce54f',
        negative: '#fce54f',
        warning: '#fce54f',
        positive: '#fce54f',
        announcement: '#fce54f',
    },
    essential: {
        base: '#fce54f',
        brightAccent: '#ffffff',
        subdued: '#fce54f',
        negative: '#fce54f',
        warning: '#fce54f',
        positive: '#fce54f',
        announcement: '#fce54f',
    },
    decorative: { base: '#fce54f', subdued: '#cd2fb0' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumSet = {
    background: {
        base: '#ffd2d7',
        highlight: '#ffe5e8',
        press: '#ffadb6',
        elevated: { base: '#ffe5e8', highlight: '#ffe5e8', press: '#ffadb6' },
        tinted: { base: '#ffd2d7', highlight: '#ffd2d7', press: '#ffd2d7' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#ffb9c1' },
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use the premium set instead.
 */
exports.premiumAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#ffd2d7',
        brightAccent: '#ffffff',
        subdued: '#ffd2d7',
        negative: '#ffd2d7',
        warning: '#ffd2d7',
        positive: '#ffd2d7',
        announcement: '#ffd2d7',
    },
    essential: {
        base: '#ffd2d7',
        brightAccent: '#ffffff',
        subdued: '#ffd2d7',
        negative: '#ffd2d7',
        warning: '#ffd2d7',
        positive: '#ffd2d7',
        announcement: '#ffd2d7',
    },
    decorative: { base: '#ffd2d7', subdued: '#1f1f1f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumDuoSet = {
    background: {
        base: '#ffc862',
        highlight: '#ffd994',
        press: '#fda400',
        elevated: { base: '#ffd994', highlight: '#ffd994', press: '#fda400' },
        tinted: { base: '#ffc862', highlight: '#ffc862', press: '#ffc862' },
    },
    text: {
        base: '#000000',
        brightAccent: '#000000',
        subdued: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        brightAccent: '#000000',
        subdued: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#ffb223' },
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use the premiumDuo set instead.
 */
exports.premiumDuoAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#ffffff',
        brightAccent: '#ffc862',
        subdued: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        brightAccent: '#ffc862',
        subdued: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#1f1f1f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumStudentSet = {
    background: {
        base: '#c4b1d4',
        highlight: '#cebfdc',
        press: '#b197c6',
        elevated: { base: '#cebfdc', highlight: '#cebfdc', press: '#b197c6' },
        tinted: { base: '#c4b1d4', highlight: '#c4b1d4', press: '#c4b1d4' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#b299c7' },
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use the premiumStudent set instead.
 */
exports.premiumStudentAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#c4b1d4',
        brightAccent: '#ffffff',
        subdued: '#c4b1d4',
        negative: '#c4b1d4',
        warning: '#c4b1d4',
        positive: '#c4b1d4',
        announcement: '#c4b1d4',
    },
    essential: {
        base: '#c4b1d4',
        brightAccent: '#ffffff',
        subdued: '#c4b1d4',
        negative: '#c4b1d4',
        warning: '#c4b1d4',
        positive: '#c4b1d4',
        announcement: '#c4b1d4',
    },
    decorative: { base: '#c4b1d4', subdued: '#1f1f1f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumFamilySet = {
    background: {
        base: '#a5bbd1',
        highlight: '#b5c7d9',
        press: '#87a5c2',
        elevated: { base: '#b5c7d9', highlight: '#b5c7d9', press: '#87a5c2' },
        tinted: { base: '#a5bbd1', highlight: '#a5bbd1', press: '#a5bbd1' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#88a5c2' },
};
/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use the premiumFamily set instead.
 */
exports.premiumFamilyAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#a5bbd1',
        brightAccent: '#ffffff',
        subdued: '#a5bbd1',
        negative: '#a5bbd1',
        warning: '#a5bbd1',
        positive: '#a5bbd1',
        announcement: '#a5bbd1',
    },
    essential: {
        base: '#a5bbd1',
        brightAccent: '#ffffff',
        subdued: '#a5bbd1',
        negative: '#a5bbd1',
        warning: '#a5bbd1',
        positive: '#a5bbd1',
        announcement: '#a5bbd1',
    },
    decorative: { base: '#a5bbd1', subdued: '#1f1f1f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumMiniSet = {
    background: {
        base: '#cff56a',
        highlight: '#eefccb',
        press: '#a5de0f',
        elevated: { base: '#eefccb', highlight: '#eefccb', press: '#a5de0f' },
        tinted: { base: '#cff56a', highlight: '#cff56a', press: '#cff56a' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#a8e20f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.audiobooksAccessOnlySet = {
    background: {
        base: '#c9e3db',
        highlight: '#e0efea',
        press: '#9ecdbe',
        elevated: { base: '#e0efea', highlight: '#e0efea', press: '#9ecdbe' },
        tinted: { base: '#c9e3db', highlight: '#c9e3db', press: '#c9e3db' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#a7d1c4' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.basicTierSet = {
    background: {
        base: '#f6f6f6',
        highlight: '#e7e7e7',
        press: '#bfbfbf',
        elevated: { base: '#e7e7e7', highlight: '#e7e7e7', press: '#bfbfbf' },
        tinted: { base: '#f6f6f6', highlight: '#f6f6f6', press: '#f6f6f6' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#d6d6d6' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.basicTierAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#f6f6f6',
        subdued: '#f6f6f6',
        brightAccent: '#f6f6f6',
        negative: '#f6f6f6',
        warning: '#f6f6f6',
        positive: '#f6f6f6',
        announcement: '#f6f6f6',
    },
    essential: {
        base: '#f6f6f6',
        subdued: '#f6f6f6',
        brightAccent: '#f6f6f6',
        negative: '#f6f6f6',
        warning: '#f6f6f6',
        positive: '#f6f6f6',
        announcement: '#f6f6f6',
    },
    decorative: { base: '#f6f6f6', subdued: '#1f1f1f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumFallbackSet = {
    background: {
        base: '#f8f8f8',
        highlight: '#e9e9e9',
        press: '#c1c1c1',
        elevated: { base: '#e9e9e9', highlight: '#e9e9e9', press: '#c1c1c1' },
        tinted: { base: '#f8f8f8', highlight: '#f8f8f8', press: '#f8f8f8' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#d8d8d8' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumFallbackAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#f8f8f8',
        subdued: '#f8f8f8',
        brightAccent: '#f8f8f8',
        negative: '#f8f8f8',
        warning: '#f8f8f8',
        positive: '#f8f8f8',
        announcement: '#f8f8f8',
    },
    essential: {
        base: '#f8f8f8',
        subdued: '#f8f8f8',
        brightAccent: '#f8f8f8',
        negative: '#f8f8f8',
        warning: '#f8f8f8',
        positive: '#f8f8f8',
        announcement: '#f8f8f8',
    },
    decorative: { base: '#f8f8f8', subdued: '#1f1f1f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyFreeSet = {
    background: {
        base: '#b3b3b3',
        highlight: '#bfbfbf',
        press: '#9d9d9d',
        elevated: { base: '#bfbfbf', highlight: '#bfbfbf', press: '#9d9d9d' },
        tinted: { base: '#b3b3b3', highlight: '#b3b3b3', press: '#b3b3b3' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#9b9b9b' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.spotifyFreeAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#b3b3b3',
        brightAccent: '#ffffff',
        subdued: '#b3b3b3',
        negative: '#b3b3b3',
        warning: '#b3b3b3',
        positive: '#b3b3b3',
        announcement: '#b3b3b3',
    },
    essential: {
        base: '#b3b3b3',
        brightAccent: '#ffffff',
        subdued: '#b3b3b3',
        negative: '#b3b3b3',
        warning: '#b3b3b3',
        positive: '#b3b3b3',
        announcement: '#b3b3b3',
    },
    decorative: { base: '#b3b3b3', subdued: '#1f1f1f' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumLiteSet = {
    background: {
        base: '#c5f0c9',
        highlight: '#e6f9e8',
        press: '#81de8a',
        elevated: { base: '#e6f9e8', highlight: '#e6f9e8', press: '#81de8a' },
        tinted: { base: '#c5f0c9', highlight: '#c5f0c9', press: '#c5f0c9' },
    },
    text: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    essential: {
        base: '#000000',
        subdued: '#000000',
        brightAccent: '#000000',
        negative: '#000000',
        warning: '#000000',
        positive: '#000000',
        announcement: '#000000',
    },
    decorative: { base: '#000000', subdued: '#a3e7a9' },
};
/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
exports.premiumLiteAlternateSet = {
    background: {
        base: '#000000',
        highlight: '#141414',
        press: '#343434',
        elevated: { base: '#141414', highlight: '#141414', press: '#343434' },
        tinted: { base: '#000000', highlight: '#000000', press: '#000000' },
    },
    text: {
        base: '#c5f0c9',
        brightAccent: '#ffffff',
        subdued: '#c5f0c9',
        negative: '#c5f0c9',
        warning: '#c5f0c9',
        positive: '#c5f0c9',
        announcement: '#c5f0c9',
    },
    essential: {
        base: '#c5f0c9',
        brightAccent: '#ffffff',
        subdued: '#c5f0c9',
        negative: '#c5f0c9',
        warning: '#c5f0c9',
        positive: '#c5f0c9',
        announcement: '#c5f0c9',
    },
    decorative: { base: '#c5f0c9', subdued: '#1f1f1f' },
};
